import '.aw{flex-shrink:0;}.ssr-plugin'
import '.p{padding:1rem;}.ssr-plugin'
import '.a0{width:100%;}.ssr-plugin'
import '.bo{height:100%;}.ssr-plugin'
import '.bj{border:none;}.ssr-plugin'
import '.bk{background-color:transparent;}.ssr-plugin'
import '.bp{border-radius:0px;}.ssr-plugin'
import '.j{display:flex;}.ssr-plugin'
import '.v{flex-direction:column;}.ssr-plugin'
import '.ae{align-items:stretch;}.ssr-plugin'
import '.bq{position:sticky;}.ssr-plugin'
import '.br{top:4rem;}.ssr-plugin'
import '.bs{z-index:7;}.ssr-plugin'
import '.ah{background-color:var(--shades-white);}.ssr-plugin'
import '.bt{padding-bottom:1rem;}.ssr-plugin'
import '.s{margin-bottom:1rem;}.ssr-plugin'
import '.bu{border-bottom:var(--blue-border);}.ssr-plugin'
import '.a8{position:fixed;}.ssr-plugin'
import '.bv{top:0px;}.ssr-plugin'
import '.bw{left:0px;}.ssr-plugin'
import '.bx{right:0px;}.ssr-plugin'
import '.by{bottom:0px;}.ssr-plugin'
import '.bz{z-index:9999;}.ssr-plugin'
import '.c0{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.c1{justify-content:flex-end;}.ssr-plugin'
import '.c2{flex:1;}.ssr-plugin'
import '.ai{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="aw p a0 bo bj bk bp"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="j v ae"
    >
      <div className="bq br bs ah bt s bu j"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="a8 bv bw bx by bz ah c0 j v"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="p j c1 bu"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="c2 ai">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
